<template>
  <div
    class="card bg-base-200 shadow-sm hover:shadow-md transition-shadow cursor-pointer"
    @click="goToCategory(item.uuid)"
  >
    <div class="card-body p-3 flex flex-col justify-between">
      <h3 class="card-title text-sm font-bold">{{ item.name }}</h3>
      <div>
        <div class="flex justify-between items-center mt-2">
          <div class="text-xs">
            <span>进度</span>
            <span class="ml-1">{{ item.answerProgressPercent }}%</span>
          </div>
          <div class="text-xs">
            <span>{{ item.questionzzCount }}道</span>
          </div>
        </div>
        <progress
          class="progress progress-primary w-full mt-1"
          :value="item.answerProgressPercent"
          max="100"
        ></progress>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { RoleplayQuestionCategory, Mate } from "@/types/entity";
import { useRouter } from "vue-router";

const router = useRouter();
const props = defineProps<{
  item: RoleplayQuestionCategory;
  mate?: Mate;
  isExplore?: boolean;
}>();

const goToCategory = (uuid: string) => {
  if (props.isExplore) {
    router.push({
      name: "roleplayExplore",
      query: {
        mateId: props.mate?.id,
        categoryId: props.item.id,
      },
    });
  } else {
    router.push({
      name: "roleplayList",
      params: { uuid },
      query: { mateUuid: props.mate?.uuid, mateId: props.mate?.id },
    });
  }
};
</script>
